$(() => {
  $('.summary-toggle').on('click', function () {
    $(this).closest('.summary').toggleClass('toggled')

    $(this).next('.summary-list').slideToggle(300)
  })
})
